import { render, staticRenderFns } from "./talentCount.vue?vue&type=template&id=766b35a3"
import script from "./talentCount.vue?vue&type=script&lang=js"
export * from "./talentCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports